import * as React from 'react'
import {
    ProductCalculationDetailsState
} from './ProductCalculationDetailsState'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import {ProductCalculationDetailsAction} from './ProductCalculationDetailsActions'
import TextField from 'material-ui/TextField'
import {errorMessage} from '../../Data/FormValidation'

export function ProductCalculationCreateMessageModal({state, dispatch}: {
    state: ProductCalculationDetailsState,
    dispatch: (action: ProductCalculationDetailsAction) => void,
}) {
    return (
        <div>
            <Dialog
                title="Neuen Eintrag erstellen"
                actions={CreateMessageModalActions(state.createNewMessageModal, dispatch)}
                modal={true}
                open={state.createNewMessageModal !== null}
            >
                <div style={{width: '100%', boxSizing: 'border-box', padding: '8px'}}>
                    <TextField
                        style={{width: '100%'}}
                        floatingLabelText="Deutscher Begriff"
                        value={state.createNewMessageModalTranslation}
                        onChange={(event, value) => dispatch({
                            type: 'NewMessageInputChange',
                            language: 'DE',
                            value: value
                        })}
                        errorText={errorMessage(state.createNewMessageModalTranslationValidation)}
                    /><br/>
                    <TextField
                        style={{width: '100%'}}
                        floatingLabelText="Englischer Begriff"
                        value={state.createNewMessageModalInput}
                        onChange={(event, value) => dispatch({
                            type: 'NewMessageInputChange',
                            language: 'EN',
                            value: value
                        })}
                        errorText={errorMessage(state.createNewMessageModalInputValidation)}
                    /><br/>
                </div>
            </Dialog>
        </div>
    )
}

function CreateMessageModalActions(typeName: string | null,
                                   dispatch: (action: ProductCalculationDetailsAction) => void) {
    const createButton = (typeName === null)
        ? (
            <FlatButton
                label={'Erstellen'}
                primary={true}
                onClick={() => {
                    dispatch({
                        type: 'SaveNewMessage'
                    })
                }}
            />
        )
        : (
            <FlatButton
                label={'Erstellen und als ' + getTypeName(typeName) + ' eintragen'}
                primary={true}
                onClick={() => {
                    dispatch({
                        type: 'SaveNewMessage'
                    })
                }}
            />
        )
    return [
        (
            <FlatButton
                label="Abbrechen"
                primary={true}
                onClick={() => {
                    dispatch({
                        type: 'CancelCreateNewMessageModal'
                    })
                }}
            />
        ),
        createButton
    ]
}

function getTypeName(type: string): string {
    switch (type) {
        case 'type':
            return 'Typ'
        case 'format':
            return 'Format'
        case 'coverage':
            return 'Umfang'
        case 'print':
            return 'Druck'
        case 'paper':
            return 'Papier'
        case 'processing':
            return 'Verarbeitung'
        default:
            return 'Nicht gefunden'
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationDetails/ProductCalculationCreateMessageModal.tsx